import React from 'react'
import { Link } from "react-router-dom";


const GeneralMedicine = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>सामान्य दवा</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                <li className="breadcrumb-item">सामान्य दवा</li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा</span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>

      <section className="content-inner service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 single-inner order-lg-1">
              <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                <img src="./assets/img/General Medicine.webp" alt className="object-fit-cover" />
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <h2>सामान्य दवा</h2>
                <p>ओमकार मल्टीस्पेशलिटी हॉस्पिटल में, जनरल मेडिसिन या इंटरनल मेडिसिन डिपार्टमेंट बड़ों की उन मेडिकल दिक्कतों का इलाज करता है जिनके लिए सर्जरी की ज़रूरत नहीं होती। इस फील्ड में डायबिटीज़, हाई ब्लड प्रेशर, दिल की बीमारी, गठिया, अस्थमा और दूसरी बीमारियाँ अक्सर देखी जाती हैं। इस डिपार्टमेंट की मुख्य ज़िम्मेदारी मरीज़ की पहचान करना, उसका इलाज करना और अगर हो सके तो उसे ठीक होने के रास्ते पर लाना है।</p>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅  लीवर, किडनी एवं फेफेड़ों से संबंधित समस्याओं का ईलाज सफलतापूर्वक किया जाता है</li>
                  <li>  ✅  अस्थमा (दमा) एवं श्वास संबंधी रोगों का ईलाज</li>
                  <li>  ✅  पेट से संबंधित सभी समस्याओं का ईलाज</li>
                  <li>  ✅ सभी प्रकार के सामान्य बुखार का ईलाज </li>
                  <li>  ✅ डेंगू, मलेरिया, टायफाइड का ईलाज </li>
                  <li>  ✅ डायबिटी से संबंधित रोगों का ईलाज</li>
                  <li>  ✅  ब्लड प्रेशर से संबंधित रोगों का ईलाज</li>
                  <li>  ✅ भर्ती की सुविधा </li>
                  <li>  ✅ ब्रेन स्ट्रोक </li>
                  <li>  ✅  अन्य सभी अपाताकालीन सुविधाएँ उपलब्ध हैं</li>

                </ul>
              </div>
            </div>
            <div className="col-lg-4 m-b30">
              <aside className="side-bar sticky-top left">
                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                  <div className="widget-title">
                    <h4 className="title">सभी सेवाएँ</h4>
                  </div>
                  <ul>
                    <li className="active"><Link to="/general-medicine">सामान्य दवा</Link></li>
                    <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                    <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                    <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                    <li ><Link to="/urology">यूरोलॉजी</Link></li>
                    <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                    <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                    <li><Link to="/ent">कान, नाक और गले</Link></li>
                    <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                    <li><Link to="/dental">डेंटल</Link></li>
                    <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                    <li><Link to="/gynaecology">ऑब्सटेट्रिक्स और गायनेकोलॉजी</Link></li>
                    <li><Link to="/paediatrics">पीडियाट्रिक्स</Link></li>
                  </ul>
                </div>
                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                  <div className="widget-content">
                    <img src="./assets/images/question.png" width={80} alt />
                    <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                    <div className="phone-number">
                      <a href="tel:+919165155945">+91 9165155945</a>
                    </div>
                    <div className="email">
                      <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                        @gmail.com</a>
                    </div>
                    <div className="link-btn">
                      <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                        Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default GeneralMedicine